import Divider from '@mui/material/Divider';
import React from "react";
import { useFormik, FieldArray, FormikProvider } from "formik";
import * as Yup from "yup";

function Invoice() {

  const validationSchema = Yup.object({
    invoiceNo: Yup.string().required("Invoice No is required"),
    date: Yup.date().required("Date is required"),
    address: Yup.string().required("Address is required"),
    contactNo: Yup.string().matches(/^\d{10}$/, "Enter a valid 10-digit number").required("Contact No is required"),
    email: Yup.string().email("Invalid email format").required("Email is required"),
    gstin: Yup.string().required("GSTIN is required"),
    panNo: Yup.string().required("PAN No is required"),
    partyDetails: Yup.string().required("Party Details are required"),
    items: Yup.array().of(
      Yup.object().shape({
        description: Yup.string().required("Description is required"),
        hsnCode: Yup.string().required("HSN/SAC Code is required"),
        quantity: Yup.number().positive("Must be positive").required("Quantity is required"),
        rate: Yup.number().positive("Must be positive").required("Rate is required"),
        amount: Yup.number().positive("Must be positive").required("Amount is required"),
      })
    ),
  });

  const formik = useFormik({
    initialValues: {
      invoiceNo: "",
      date: "",
      address: "",
      contactNo: "",
      email: "",
      gstin: "",
      panNo: "",
      partyDetails: "",
      items: [{ description: "", hsnCode: "", quantity: "", rate: "", amount: "" }],
    },
    validationSchema,
    onSubmit: (values) => {
   
    },
  });

  return (
    <>
      <main style={{ width: "100%", height: "100%" }}>
        <div className="row">
          <div style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }} className="col-12 mb-4 d-flex justify-content-between">

            <div className="d-flex">
              <h4 className='m-0 p-3'>
                Invoice
              </h4>

            </div>

            <div className='d-flex align-items-center justify-content-end gap-3'>
              <div className='d-flex align-items-center gap-3'>
                <div className="position-relative div-okij8ijj">
                  <input type="text" className="form-control div-TzEiOdMeYO" placeholder='Search here' style={{ padding: "0px 1.7rem 0px .5rem", borderRadius: ".3rem" }} />
                  <div className="position-absolute" style={{ top: "10px", right: '8px' }}>
                    <button style={{ background: "none", border: 'none', }}><i class="fa-solid fa-magnifying-glass"></i></button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          {/* <div className="col-12 d-flex align-items-center mb-4 justify-content-end">
           
        </div> */}
        </div>
        <div className="row">
          <div style={{ height: "42rem" }} className="col-12 row">
            <div className="col-5 p-3" style={{ overflowY: "scroll", border: "1px solid #D6DADD", borderRadius: "6px", height: "100%" }}>
              <span style={{ backgroundColor: "#C6FFD7", borderRadius: "5px", cursor: "pointer" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                <span>
                  <img src="/Images/Group9.png" alt="" />
                </span>
                <span className="d-flex flex-column align-items-start">
                  <span className="m-1">Patient Invoice</span>
                  <span style={{ color: "gray" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                </span>
                <span className="d-flex flex-column align-items-start">
                  <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Jeffery Nichols</span></span>
                  <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                </span>
              </span>


            </div>
            <div className="col-7 px-3">
              <div className="col-12 d-flex flex-column" style={{ overflowY: "scroll", border: "1px solid #D6DADD", borderRadius: "6px", height: "100%", backgroundColor: "white" }}>
                <div className="d-flex py-3 px-4 col-12 justify-content-between" style={{ borderBottom: "1px dashed gray" }}>
                  <span>Invoive</span>
                  <button className='border-0 rounded-5 d-flex gap-2' style={{ background: "#F46B68", color: "#fff", padding: '.2rem 1rem' }}>
                    <span><i class="material-icons d-flex align-items-center" style={{ fontSize: "1.2rem" }}>picture_as_pdf</i></span>
                    <span>Prescription.pdf</span>
                    <span><i class="fa-solid fa-download"></i></span>
                  </button>
                </div>
                <div className="d-flex flex-column px-4 py-4">
                  <div className="d-flex align-items-center justify-content-between my-2">
                    <h5>Jordan .M</h5>
                    <span>Age : 68</span>
                    <span>Blood Group : O+</span>
                    <span>BP : 120/80</span>
                    <span>Pulse : 40 – 60 bpm</span>
                    <span style={{ color: "gray" }}>#123456abc</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between my-2">
                    <span className="d-flex">Assigned to <span className="mx-1" style={{ color: "#2662F0" }}>DR. Jeffery Nichols</span></span>
                    <span className="d-flex">Department <span className="mx-1" style={{ color: "#2662F0" }}>General Physician</span></span>
                    <span style={{ color: "gray" }}>Sat, 23 Jul 2020, 01:24 PM</span>
                  </div>
                  <Divider className="my-2" style={{ borderColor: "gray" }} />
                  <div className="d-flex flex-column">
                    <h2 className="text-center">Medical Invoice Form</h2>
                    <form onSubmit={formik.handleSubmit} className="border p-4">
                      {/* Invoice Details */}
                      <div className="mb-3">
                        <label className="form-label">Invoice No:</label>
                        <input
                          type="text"
                          className="form-control"
                          {...formik.getFieldProps("invoiceNo")}
                        />
                        {formik.touched.invoiceNo && formik.errors.invoiceNo ? (
                          <div className="text-danger">{formik.errors.invoiceNo}</div>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Date:</label>
                        <input type="date" className="form-control" {...formik.getFieldProps("date")} />
                        {formik.touched.date && formik.errors.date ? (
                          <div className="text-danger">{formik.errors.date}</div>
                        ) : null}
                      </div>

                      {/* Party Details */}
                      <div className="mb-3">
                        <label className="form-label">Address:</label>
                        <input type="text" className="form-control" {...formik.getFieldProps("address")} />
                        {formik.touched.address && formik.errors.address ? (
                          <div className="text-danger">{formik.errors.address}</div>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Contact No:</label>
                        <input type="text" className="form-control" {...formik.getFieldProps("contactNo")} />
                        {formik.touched.contactNo && formik.errors.contactNo ? (
                          <div className="text-danger">{formik.errors.contactNo}</div>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Email:</label>
                        <input type="email" className="form-control" {...formik.getFieldProps("email")} />
                        {formik.touched.email && formik.errors.email ? (
                          <div className="text-danger">{formik.errors.email}</div>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <label className="form-label">GSTIN:</label>
                        <input type="text" className="form-control" {...formik.getFieldProps("gstin")} />
                        {formik.touched.gstin && formik.errors.gstin ? (
                          <div className="text-danger">{formik.errors.gstin}</div>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <label className="form-label">PAN No:</label>
                        <input type="text" className="form-control" {...formik.getFieldProps("panNo")} />
                        {formik.touched.panNo && formik.errors.panNo ? (
                          <div className="text-danger">{formik.errors.panNo}</div>
                        ) : null}
                      </div>

                      {/* Party Details */}
                      <div className="mb-3">
                        <label className="form-label">Party Details:</label>
                        <textarea className="form-control" {...formik.getFieldProps("partyDetails")} />
                        {formik.touched.partyDetails && formik.errors.partyDetails ? (
                          <div className="text-danger">{formik.errors.partyDetails}</div>
                        ) : null}
                      </div>

                      {/* Items Table */}
                      <FormikProvider value={formik}>
                        <FieldArray name="items">
                          {({ push, remove }) => (
                            <>
                              <h4>Items</h4>
                              {formik.values.items.map((item, index) => (
                                <div key={index} className="border p-3 mb-2">
                                  <div className="mb-2">
                                    <label>Description:</label>
                                    <input type="text" className="form-control" {...formik.getFieldProps(`items.${index}.description`)} />
                                  </div>
                                  <div className="mb-2">
                                    <label>HSN / SAC Code:</label>
                                    <input type="text" className="form-control" {...formik.getFieldProps(`items.${index}.hsnCode`)} />
                                  </div>
                                  <div className="mb-2">
                                    <label>Quantity:</label>
                                    <input type="number" className="form-control" {...formik.getFieldProps(`items.${index}.quantity`)} />
                                  </div>
                                  <div className="mb-2">
                                    <label>Rate:</label>
                                    <input type="number" className="form-control" {...formik.getFieldProps(`items.${index}.rate`)} />
                                  </div>
                                  <div className="mb-2">
                                    <label>Amount:</label>
                                    <input type="number" className="form-control" {...formik.getFieldProps(`items.${index}.amount`)} />
                                  </div>
                                  <button type="button" className="btn btn-danger" onClick={() => remove(index)}>Remove</button>
                                </div>
                              ))}
                              <div className="text-end">
                                <button type="button" className="btn btn-primary" onClick={() => push({ description: "", hsnCode: "", quantity: "", rate: "", amount: "" })}>
                                  Add Item
                                </button>
                              </div>
                            </>
                          )}
                        </FieldArray>
                      </FormikProvider>
                      <div className='text-center'>
                        {/* Submit Button */}
                        <button type="submit" className="btn btn-success mt-3 w-100">Submit</button>
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>




      </main>

    </>
  )
}

export default Invoice